// DPR Skip States Action Types
export const UPDATE_DPR_SKIP_STATE = '@@team/update-dpr-skip-state';
export const RESET_DPR_SKIP_STATES = '@@team/reset-dpr-skip-states';
export const LOAD_DPR_SKIP_STATES_FOR_SECTION = '@@team/load-dpr-skip-states-for-section';
export const UPDATE_DPR_SAVED_STATE = '@@team/update-dpr-saved-state';

